import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2022/Lic/C"; 

export const licitaciones2022=[
    {
        // CONVOCATORIA NUM# 025
            'numConvocatoria' : 'Convocatoria No. 025/2022.',
            'idConvocatoria' : 'Convocatoria25',
            'procedimientos' : [
        // Licitación N110
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N110-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 5 al 9 de diciembre de 2022.',
                    'descripcionProcedimiento' : 'Casa de la Cultura Huasteca; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N110/N110.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N110/JAN110.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N110/APN110.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N110/FAN110.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 024
            'numConvocatoria' : 'Convocatoria No. 024/2022.',
            'idConvocatoria' : 'Convocatoria24',
            'procedimientos' : [
        // Licitación N109
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N109-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 5 al 9 de diciembre de 2022.',
                    'descripcionProcedimiento' : 'Centro de identificación humana para resguardo temporal de Hidalgo (obra exterior); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N109/N109.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N109/JAN109.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N109/APN109.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N109/FAN109.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 023
            'numConvocatoria' : 'Convocatoria No. 023/2022.',
            'idConvocatoria' : 'Convocatoria23',
            'procedimientos' : [
        // Licitación N108
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N108-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Pavimento de Concreto Hidráulico en acceso a cabecera municipal de Tlahuiltepa, Tramo: Tlahuiltepa - Itztacoyotla, municipio de Tlahuiltepa;  ubicada en la localidad y Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N108/N108.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N108/JAN108.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N108/APN108.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N108/FAN108.pdf`,
                    },
                    ],
                },
        // Licitación N107
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N107-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Rehabilitación de Pavimentación en la Carretera Estatal Calnali - San Andrés - Santa Lucia, municipio de Calnali;  ubicada en la localidad de Tochintlán, Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N107/N107.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N107/JAN107.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N107/APN107.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N107/FAN107.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 022
            'numConvocatoria' : 'Convocatoria No. 022/2022.',
            'idConvocatoria' : 'Convocatoria22',
            'procedimientos' : [
        // Licitación N106
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N106-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Construcción del Centro de Salud en la localidad de Santa Teresa, municipio de Yahualica;  ubicada en la localidad de Santa Teresa, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N106/N106.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N106/JAN106.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N106/APN106.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N106/FAN106.pdf`,
                    },
                    ],
                },
        // Licitación N105
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N105-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico en calle de acceso principal a la comunidad de Paredones, municipio de Acaxochitlán;  ubicada en la localidad de Paredones Huitzilingo, Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N105/N105.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N105/JAN105.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N105/APN105.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N105/FAN105.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 021
            'numConvocatoria' : 'Convocatoria No. 021/2022.',
            'idConvocatoria' : 'Convocatoria21',
            'procedimientos' : [
        // Licitación N104
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N104-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera estatal Tecamatl - Ajacuba, municipios de San Agustín Tlaxiaca y Ajacuba;  ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N104/N104.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N104/JAN104.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N104/APN104.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N104/FAN104.pdf`,
                    },
                    ],
                },
        // Licitación N103
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N103-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico de la carretera Metztitlán - Zoquizoquipan, municipio de Metztitlán;  ubicada en la localidad de Zoquizoquipan, Municipio de Metztitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N103/N103.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N103/JAN103.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N103/APN103.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N103/FAN103.pdf`,
                    },
                    ],
                },
        // Licitación N102
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N102-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción asfáltica de la carretera San Juan Tepa - Tecomatlan, municipio de Francisco I. Madero; ubicada en la localidad de San Juan Tepa, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N102/N102.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N102/JAN102.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N102/APN102.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N102/FAN102.pdf`,
                    },
                    ],
                },
        // Licitación N101
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N101-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera estatal E.C.F. Pachuca - Tempoal - San José - Coacuilco, municipio de Huejutla de Reyes; ubicada en la localidad de Coacuilco, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N101/N101.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N101/JAN101.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N101/APN101.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N101/FAN101.pdf`,
                    },
                    ],
                },
        // Licitación N100
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N100-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción carretera estatal Tenango de Doria - Huehuetla, subtramo: Santa María Temascalapa - Huehuetla tres tramos, municipios de Tenango de Doria y Huehuetla;  ubicada en varias localidades del Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N100/N100.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N100/JAN100.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N100/APN100.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }21/N100/AMDAPN100.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N100/FAN100.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }21/N100/AMDFAN100.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio al anexo No. 1',
                        'urlresultado' : `${ ligabase }21/N100/AMD1FAN100.pdf`,
                    },
                    ],
                },
        // Licitación N99
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N99-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera estatal Enzuelado - Carpinteros, municipio de San Agustín Mezquititlán;  ubicada en la localidad de El Enzuelado, Municipio de San Agustín Metzquititlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N99/N99.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N99/JAN99.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N99/APN99.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N99/FAN99.pdf`,
                    },
                    ],
                },
        // Licitación N98
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N98-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera estatal Molango Xochicoatlán, municipio de Xochicoatlán;  ubicada en la localidad y Municipio de Xochicoatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N98/N98.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N98/JAN98.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N98/APN98.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }21/N98/AMDAPN98.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N98/FAN98.pdf`,
                    },
                    ],
                },
        // Licitación N97
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N97-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera estatal Santa Cruz - Huichapa - La Corrala, municipio de Huejutla de Reyes; ubicada en la localidad de La Corrala, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N97/N97.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N97/JAN97.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N97/APN97.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N97/FAN97.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 020
            'numConvocatoria' : 'Convocatoria No. 020/2022.',
            'idConvocatoria' : 'Convocatoria20',
            'procedimientos' : [
        // Licitación N96
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N96-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Construcción de tanque de regularización en el municipio de Cardonal, en la localidad de San Miguel Tlazintla;  ubicada en la localidad de San Miguel Tlazintla, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N96/N96.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N96/JAN96.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N96/APN96.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N96/FAN96.pdf`,
                    },
                    ],
                },
        // Licitación N95
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N95-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en Circuito Paredes, municipio de Ixmiquilpan; ubicada en la localidad de Capula, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N95/N95.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N95/JAN95.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N95/APN95.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N95/FAN95.pdf`,
                    },
                    ],
                },
        // Licitación N94
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N94-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en el municipio de Cardonal en la localidad del Bingu, en diferentes calles;  ubicada en la localidad de El Bingú, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N94/N94.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N94/JAN94.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N94/APN94.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N94/FAN94.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 019
            'numConvocatoria' : 'Convocatoria No. 019/2022.',
            'idConvocatoria' : 'Convocatoria19',
            'procedimientos' : [
        // Licitación N93
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N93-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de aoctubre al 3 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Mejoramiento del Módulo de Medidas Especiales; ubicado en la localidad de Los Encinos, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N93/N93.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N93/JAN93.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N93/APN93.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N93/FAN93.pdf`,
                    },
                    ],
                },
        // Licitación N92
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N92-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de aoctubre al 3 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Mejoramiento del CERESO de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N92/N92.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N92/JAN92.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N92/APN92.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N92/FAN92.pdf`,
                    },
                    ],
                },
        // Licitación N91
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N91-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de aoctubre al 3 de noviembre de 2022.',
                    'descripcionProcedimiento' : 'Mejoramiento de la Base de Operaciones de Ixmiquilpan, Hgo. de la Secretaría de Seguridad Pública; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }19/N91/N91.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N91/JAN91.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N91/APN91.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N91/FAN91.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 018
            'numConvocatoria' : 'Convocatoria No. 018/2022.',
            'idConvocatoria' : 'Convocatoria18',
            'procedimientos' : [
        // Licitación N90
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N90-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de octubre de 2022.',
                    'descripcionProcedimiento' : 'Construcción del sistema de agua potable para beneficiar a la localidad de Tepepa Santiago Tepepa primer etapa consiste en la red de distribución en varias AGEBS, ubicada en la localidad de Tepepa (Santiago Tepepa), Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N90/N90.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N90/JAN90.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N90/APN90.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N90/FAN90.pdf`,
                    },
                    ],
                },
        // Licitación N89
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N89-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de octubre de 2022.',
                    'descripcionProcedimiento' : 'Terminación de Elevadores de Puentes Peatonales (IMSS - SEP - Juan C. Doria); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }18/N89/N89.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N89/JAN89.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N89/APN89.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N89/FAN89.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 017
            'numConvocatoria' : 'Convocatoria No. 017/2022.',
            'idConvocatoria' : 'Convocatoria17',
            'procedimientos' : [
        // Licitación N88
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N88-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción del pozo profundo de agua potable para beneficiar a la localidad de El Deca en el municipio de Cardonal; ubicada en la localidad de El Deca, Municipio de Cardonal, Estado de Hidalgo. (Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }17/N88/N88.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N88/JAN88.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N88/APN88.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N88/FAN88.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 016
            'numConvocatoria' : 'Convocatoria No. 016/2022.',
            'idConvocatoria' : 'Convocatoria16',
            'procedimientos' : [
        // Licitación N87
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N87-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca, torre hospitalaria, área de recuperación; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N87/N87.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N87/JAN87.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N87/APN87.pdf`,
                    },
                    ],
                },
        // Licitación N86
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N86-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Terminación de Elevadores de Puentes Peatonales (IMSS - SEP -Juan C. Doria); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N86/N86.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N86/JAN86.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N86/APN86.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 015
            'numConvocatoria' : 'Convocatoria No. 015/2022.',
            'idConvocatoria' : 'Convocatoria15',
            'procedimientos' : [
        // Licitación N85
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N85-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 12 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Chapantongo; ubicada en varias localidades del Municipio de Chapantongo, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }15/N85/N85.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N85/JAN85.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N85/APN85.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N85/FAN85.pdf`,
                    },
                    ],
                },
        // Licitación N84
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N84-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 12 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de la planta de tratamiento de aguas residuales para beneficiar a la localidad de Mangocuatitla en el municipio de Yahualica; ubicada en la localidad de Mangocuatitla, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N84/N84.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N84/JAN84.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N84/APN84.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N84/FAN84.pdf`,
                    },
                    ],
                },
        // Licitación N83
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N83-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 12 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Jaltocán; ubicada en varias localidades del Municipio de Jaltocán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N83/N83.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N83/JAN83.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N83/APN83.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N83/FAN83.pdf`,
                    },
                    ],
                },
        // Licitación N82
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N82-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 12 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Ixmiquilpan; ubicada en la localidad de Maguey Blanco, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N82/N82.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N82/JAN82.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N82/APN82.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N82/FAN82.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 014
            'numConvocatoria' : 'Convocatoria No. 014/2022.',
            'idConvocatoria' : 'Convocatoria14',
            'procedimientos' : [
        // Licitación N81
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N81-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 1 al 9 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Huichapan; ubicada en Varias localidades del Municipio de Huichapan, Estado de Hidalgo. (Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }14/N81/N81.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N81/JAN81.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N81/APN81.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N81/FAN81.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 013
            'numConvocatoria' : 'Convocatoria No. 013/2022.',
            'idConvocatoria' : 'Convocatoria13',
            'procedimientos' : [
        // Licitación N80
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N80-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de San Bartolo Tutotepec; ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N80/N80.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N80/JAN80.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N80/APN80.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N80/FAN80.pdf`,
                    },
                    ],
                },
        // Licitación N79
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N79-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de auditorio, Villa Aquiles Serdán, municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N79/N79.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N79/JAN79.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N79/APN79.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N79/FAN79.pdf`,
                    },
                    ],
                },
        // Licitación N78
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N78-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de agosto de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en acceso a Las Grutas de Tolantongo, municipio de Cardonal; ubicada en la localidad de San Cristóbal, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N78/N78.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N78/JAN78.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N78/APN78.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N78/FAN78.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 012
            'numConvocatoria' : 'Convocatoria No. 012/2022.',
            'idConvocatoria' : 'Convocatoria12',
            'procedimientos' : [
        // Licitación N77
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N77-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Acaxochitlán; ubicada en la localidad de Tlamimilolpa, Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N77/N77.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N77/JAN77.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N77/APN77.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N77/FAN77.pdf`,
                    },
                    ],
                },
        // Licitación N76
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N76-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Cuautepec de Hinojosa; ubicada en la localidad de Santa Elena Paliseca, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N76/N76.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N76/JAN76.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N76/APN76.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N76/FAN76.pdf`,
                    },
                    ],
                },
        // Licitación N75
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N75-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de sanitario con biodigestor, en el municipio de Pacula; ubicada en la localidad de La Mohonera, Municipio de Pacula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N75/N75.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N75/JAN75.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N75/APN75.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N75/FAN75.pdf`,
                    },
                    ],
                },
        // Licitación N74
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N74-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de sanitario con biodigestor, en el municipio de Tlahuiltepa; ubicada en Varias localidades del Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N74/N74.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N74/JAN74.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N74/APN74.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N74/FAN74.pdf`,
                    },
                    ],
                },
        // Licitación N73
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N73-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Huasca de Ocampo; ubicada en la localidad de Huasca de Ocampo, Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N73/N73.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N73/JAN73.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N73/APN73.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N73/FAN73.pdf`,
                    },
                    ],
                },
        // Licitación N72
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N72-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Pisaflores; ubicada en Varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N72/N72.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N72/JAN72.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N72/APN72.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N72/FAN72.pdf`,
                    },
                    ],
                },
        // Licitación N71
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N71-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 2 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de San Felipe Orizatlán; ubicada en Varias localidades del Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N71/N71.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N71/JAN71.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N71/APN71.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N71/FAN71.pdf`,
                    },
                    ],
                },
        // Licitación N70
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N70-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Tasquillo; ubicada en Varias localidades del Municipio de Tasquillo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N70/N70.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N70/JAN70.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N70/APN70.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N70/FAN70.pdf`,
                    },
                    ],
                },
        // Licitación N69
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N69-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Tlanchinol; ubicada en Varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N69/N69.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N69/JAN69.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N69/APN69.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N69/FAN69.pdf`,
                    },
                    ],
                },
        // Licitación N68
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N68-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Tulancingo de Bravo; ubicada en la localidad de Santa Ana Hueytlalpan, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N68/N68.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N68/JAN68.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N68/APN68.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N68/FAN68.pdf`,
                    },
                    ],
                },
        // Licitación N67
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N67-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Ampliación del sistema de agua potable en la localidad de El Deca en el municipio de Cardonal; ubicada en la localidad de El Deca, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N67/N67.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N67/JAN67.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N67/APN67.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N67/FAN67.pdf`,
                    },
                    ],
                },
        // Licitación N66
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N66-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Zimapán; ubicada en Varias localidades del Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N66/N66.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N66/JAN66.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N66/APN66.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N66/FAN66.pdf`,
                    },
                    ],
                },
        // Licitación N65
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N65-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de la planta de tratamiento de aguas residuales para beneficiar a la localidad de Zacualoya en el municipio de Chilcuautla; ubicada en la localidad de Zacualoya, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N65/N65.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N65/JAN65.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N65/APN65.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N65/FAN65.pdf`,
                    },
                    ],
                },
        // Licitación N64
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N64-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción de la red de alcantarillado primera etapa para beneficiar a la localidad de Zacualoya en el municipio de Chilcuautla; ubicada en la localidad de Zacualoya, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N64/N64.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N64/JAN64.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N64/APN64.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N64/FAN64.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }12/N64/AMDFAN64.pdf`,
                    },
                    ],
                },
        // Licitación N63
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N63-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 de julio al 1 de agosto  de 2022.',
                    'descripcionProcedimiento' : 'Construcción del pozo profundo de agua potable para beneficiar a la localidad de El Deca en el municipio de Cardonal; ubicada en la localidad de El Deca, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N63/N63.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N63/JAN63.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N63/APN63.pdf`,
                    },
                    ],
                },
        // Licitación N62
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N62-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción del pozo profundo de agua potable para beneficiar a la localidad de Santa Ana Hueytlalpan en el municipio de Tulancingo de Bravo; ubicada en la localidad de Santa Ana Hueytlalpan, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N62/N62.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N62/JAN62.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N62/APN62.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N62/FAN62.pdf`,
                    },
                    ],
                },
        // Licitación N61
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N61-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de sanitario con biodigestor, en el municipio de Acaxochitlán; ubicada en la localidad de Apapaxtla el Grande (Altamira), Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N61/N61.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N61/JAN61.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N61/APN61.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N61/FAN61.pdf`,
                    },
                    ],
                },
        // Licitación N60
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N60-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Calnali; ubicada en la localidad de Papatlatla, Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N60/N60.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N60/JAN60.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N60/APN60.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N60/FAN60.pdf`,
                    },
                    ],
                },
        // Licitación N59
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N59-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de sanitario con biodigestor, en el municipio de Huazalingo; ubicada en Varias localidades del Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N59/N59.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N59/JAN59.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N59/APN59.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N59/FAN59.pdf`,
                    },
                    ],
                },
        // Licitación N58
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N58-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de sanitario con biodigestor, en el municipio de Huehuetla; ubicada en la localidad de Santa Inés, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N58/N58.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N58/JAN58.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N58/APN58.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N58/FAN58.pdf`,
                    },
                    ],
                },
        // Licitación N57
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N57-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de San Bartolo Tutotepec; ubicada en Varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N57/N57.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N57/JAN57.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N57/APN57.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N57/FAN57.pdf`,
                    },
                    ],
                },
        // Licitación N56
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N56-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuarto dormitorio, en el municipio de Yahualica; ubicada en Varias localidades del Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N56/N56.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N56/JAN56.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N56/APN56.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N56/FAN56.pdf`,
                    },
                    ],
                },
        // Licitación N55
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N55-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción del sistema de alcantarillado sanitario segunda etapa para beneficiar a la localidad de Mangocuatitla en el municipio de Yahualica; ubicada en la localidad de Mangocuatitla, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N55/N55.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N55/JAN55.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N55/APN55.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N55/FAN55.pdf`,
                    },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 011
            'numConvocatoria' : 'Convocatoria No. 011/2022.',
            'idConvocatoria' : 'Convocatoria11',
            'procedimientos' : [
        // Licitación N54
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N54-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de julio de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica del camino de acceso principal a la localidad de Nopalillo, municipio de Metepec; ubicada en la localidad de Metepec, Municipio de Metepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N54/N54.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N54/JAN54.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N54/APN54.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N54/FAN54.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 010
            'numConvocatoria' : 'Convocatoria No. 010/2022.',
            'idConvocatoria' : 'Convocatoria10',
            'procedimientos' : [
        // Licitación N53
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N53-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Pisaflores; ubicada en Varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N53/N53.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N53/JAN53.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N53/APN53.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N53/FAN53.pdf`,
                    },
                    ],
                },
        // Licitación N52
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N52-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Tepehuacán de Guerrero; ubicada en Varias localidades del Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N52/N52.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N52/JAN52.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N52/APN52.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N52/FAN52.pdf`,
                    },
                    ],
                },
        // Licitación N51
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N51-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Tlanchinol; ubicada en Varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N51/N51.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N51/JAN51.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N51/APN51.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N51/FAN51.pdf`,
                    },
                    ],
                },
        // Licitación N50
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N50-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Tlahuiltepa; ubicada en Varias localidades del Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N50/N50.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N50/JAN50.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }10/N50/AMDJAN50.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N50/APN50.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N50/FAN50.pdf`,
                    },
                    ],
                },
        // Licitación N49
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N49-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Lolotla; ubicada en Varias localidades del Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N49/N49.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N49/JAN49.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N49/APN49.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N49/FAN49.pdf`,
                    },
                    ],
                },
        // Licitación N48
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N48-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de La Misión; ubicada en Varias localidades del Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N48/N48.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N48/JAN48.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }10/N48/AMDJAN48.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N48/APN48.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N48/FAN48.pdf`,
                    },
                    ],
                },
        // Licitación N47
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N47-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Huichapan; ubicada en Varias localidades del Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N47/N47.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N47/JAN47.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N47/APN47.pdf`,
                    },
                    ],
                },
        // Licitación N46
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N46-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Chapantongo; ubicada en Varias localidades del Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N46/N46.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N46/JAN46.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N46/APN46.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N46/FAN46.pdf`,
                    },
                    ],
                },
        // Licitación N45
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N45-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 18 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Acaxochitlán; ubicada en Varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N45/N45.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N45/JAN45.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N45/APN45.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N45/FAN45.pdf`,
                    },
                    ],
                },
        // Licitación N44
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N44-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Yahualica; ubicada en Varias localidades del Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N44/N44.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N44/JAN44.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N44/APN44.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N44/FAN44.pdf`,
                    },
                    ],
                },
        // Licitación N43
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N43-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Xochiatipan; ubicada en Varias localidades del Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N43/N43.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N43/JAN43.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N43/APN43.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N43/FAN43.pdf`,
                    },
                    ],
                },
        // Licitación N42
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N42-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Tianguistengo; ubicada en Varias localidades del Municipio de Tianguistengo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N42/N42.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N42/JAN42.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N42/APN42.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N42/FAN42.pdf`,
                    },
                    ],
                },
        // Licitación N41
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N41-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de San Bartolo Tutotepec; ubicada en Varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N41/N41.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N41/JAN41.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N41/APN41.pdf`,
                    },
                    ],
                },
        // Licitación N40
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N40-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Huehuetla; ubicada en Varias localidades del Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N40/N40.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N40/JAN40.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N40/APN40.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N40/FAN40.pdf`,
                    },
                    ],
                },
        // Licitación N39
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N39-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Huazalingo; ubicada en Varias localidades del Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N39/N39.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N39/JAN39.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N39/APN39.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N39/FAN39.pdf`,
                    },
                    ],
                },
        // Licitación N38
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N38-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Huautla; ubicada en Varias localidades del Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N38/N38.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N38/JAN38.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N38/APN38.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N38/FAN38.pdf`,
                    },
                    ],
                },
        // Licitación N37
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N37-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Cuarto Dormitorio, en el municipio de Atlapexco; ubicada en Varias localidades del Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N37/N37.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N37/JAN37.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N37/APN37.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N37/FAN37.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 009
            'numConvocatoria' : 'Convocatoria No. 009/2022.',
            'idConvocatoria' : 'Convocatoria9',
            'procedimientos' : [
        // Licitación N36
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N36-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de julio de 2022.',
                    'descripcionProcedimiento' : 'Construcción del Centro de Salud en la localidad de San Pedro Huaquilpan, municipio de Zapotlán de Juárez; ubicada en la localidad de San Pedro Huaquilpan, Municipio de  Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N36/N36.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N36/JAN36.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N36/APN36.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N36/FAN36.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 008
            'numConvocatoria' : 'Convocatoria No. 008/2022.',
            'idConvocatoria' : 'Convocatoria8',
            'procedimientos' : [
        // Licitación N35
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N35-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 24 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Pavimentación hidráulica en la localidad de Chiatipan, municipio de Huazalingo; ubicada en la localidad de Chiatipán, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N35/N35.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N35/JAN35.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N35/APN35.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N35/FAN35.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 007
            'numConvocatoria' : 'Convocatoria No. 007/2022.',
            'idConvocatoria' : 'Convocatoria7',
            'procedimientos' : [
        // Licitación N34
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N34-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico de acceso a cabecera, municipio de Tlahuiltepa; ubicada en la localidad y Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N34/N34.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N34/JAN34.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N34/APN34.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N34/FAN34.pdf`,
                    },
                    ],
                },
        // Licitación N33
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N33-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción de carretera Demacú – San Salvador, Demacú, municipio de san salvador; ubicada en la localidad de Demacú, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N33/N33.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N33/JAN33.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N33/APN33.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N33/FAN33.pdf`,
                    },
                    ],
                },
        // Licitación N32
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N32-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico Av. Los Hidalgos, Teofani, municipio de San Salvador; ubicada en la localidad de Teofani, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N32/N32.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N32/JAN32.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N32/APN32.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N32/FAN32.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 006
            'numConvocatoria' : 'Convocatoria No. 006/2022.',
            'idConvocatoria' : 'Convocatoria6',
            'procedimientos' : [
        // Licitación N31
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N31-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Rehabilitación de la calle paso por Santa Teresa, municipio de Yahualica; ubicada en la localidad de Santa Teresa, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }6/N31/N31.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N31/JAN31.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N31/APN31.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N31/FAN31.pdf`,
                    },
                    ],
                },
        // Licitación N30
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N30-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Pavimento Asfáltico del camino rural Otates - Cacateco, municipio de Huejutla de Reyes; ubicada en la localidad de Cacateco, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }6/N30/N30.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N30/JAN30.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N30/APN30.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N30/FAN30.pdf`,
                    },
                    ],
                },
        // Licitación N29
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N29-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Reconstrucción tramo carretero Gandho - El Geiser, del Km. 0+000 al Km. 1+500; ubicada en la localidad de Gandho, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }6/N29/N29.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N29/JAN29.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N29/APN29.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N29/FAN29.pdf`,
                    },
                    ],
                },
        // Licitación N28
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N28-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de empedrado acceso a Los Huesitos, municipio de Zempoala; ubicada en la localidad de Santo Tomás, Municipio de Zempoala, Estado de Hidalgo. (Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }6/N28/N28.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N28/JAN28.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N28/APN28.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N28/FAN28.pdf`,
                    },
                    ],
                },
        // Licitación N27
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N27-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de empedrado en la calle 5 de febrero, municipio de Zempoala; ubicada en la localidad de Santo Tomás, Municipio de Zempoala, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }6/N27/N27.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N27/JAN27.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N27/APN27.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N27/FAN27.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 005
            'numConvocatoria' : 'Convocatoria No. 005/2022.',
            'idConvocatoria' : 'Convocatoria5',
            'procedimientos' : [
        // Licitación N26
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N26-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de mayo al 3 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Boulevard La Providencia - San Fernando, en el Municipio de Mineral de la Reforma; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N26/N26.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N26/JAN26.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N26/APN26.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N26/FAN26.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 004
            'numConvocatoria' : 'Convocatoria No. 004/2022.',
            'idConvocatoria' : 'Convocatoria4',
            'procedimientos' : [
        // Licitación N25
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N25-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de mayo al 3 de junio de 2022.',
                    'descripcionProcedimiento' : 'Construcción de cuerpo derecho de Boulevard La Providencia - El Saucillo del Km 0 000 al Km 1 080, en el municipio de Mineral de la Reforma; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N25/N25.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N25/JAN25.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N25/APN25.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N25/FAN25.pdf`,
                    },
                    ],
                },
        // Licitación N24
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N24-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de mayo al 3 de junio de 2022.',
                    'descripcionProcedimiento' : 'Colector pluvial Ferrocarril Central - Dren Santa Julia, municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N24/N24.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N24/JAN24.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N24/APN24.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N24/FAN24.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 003
            'numConvocatoria' : 'Convocatoria No. 003/2022.',
            'idConvocatoria' : 'Convocatoria3',
            'procedimientos' : [
        // Licitación N23
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N23-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Sustitución y Ampliación del Hospital General de Pachuca (Cancelería Exterior); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N23/N23.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N23/JAN23.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N23/APN23.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N23/FAN23.pdf`,
                    },
                    ],
                },
        // Licitación N22
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N22-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Sustitución y Ampliación del Hospital General de Pachuca (trabajos complementarios de la construcción del edificio de consulta externa); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N22/N22.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N22/JAN22.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N22/APN22.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N22/FAN22.pdf`,
                    },
                    ],
                },
        // Licitación N21
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N21-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca (trabajos de albañilería, instalaciones y acabados en pisos superiores de auxiliares de diagnóstico); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N21/N21.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N21/JAN21.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N21/APN21.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N21/FAN21.pdf`,
                    },
                    ],
                },
        // Licitación N20
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N20-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Boulevard La Providencia - El Saucillo, municipio de Mineral de la Reforma; ubicada en la localidad de  La Providencia siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N20/N20.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N20/JAN20.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N20/APN20.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N20/FAN20.pdf`,
                    },
                    ],
                },
        // Licitación N19
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N19-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Boulevard de acceso a Téllez; ubicada en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N19/N19.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N19/JAN19.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N19/APN19.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N19/FAN19.pdf`,
                    },
                    ],
                },
        // Licitación N18
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N18-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de Puente en el cruce con el Río de las Avenidas; ubicada en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N18/N18.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N18/JAN18.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N18/APN18.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N18/FAN18.pdf`,
                    },
                    ],
                },
        // Licitación N17
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N17-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de la Avenida Revolución; ubicada en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N17/N17.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N17/JAN17.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N17/APN17.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N17/FAN17.pdf`,
                    },
                    ],
                },
        // Licitación N16
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N16-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Manejo sustentable del sistema de distribución de agua potable en la localidad de Maguey Blanco, municipio de Ixmiquilpan; ubicada en la localidad de Maguey Blanco, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N16/N16.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N16/JAN16.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N16/APN16.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N16/FAN16.pdf`,
                    },
                    ],
                },
        // Licitación N15
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N15-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de empedrado acceso a Los Huesitos, municipio de Zempoala; ubicada en la localidad de Santo Tomás, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N15/N15.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N15/JAN15.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N15/APN15.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N15/FAN15.pdf`,
                    },
                    ],
                },
        // Licitación N14
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N14-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de empedrado en la calle 5 de febrero, municipio de Zempoala; ubicada en la localidad de Santo Tomás, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N14/N14.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N14/JAN14.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N14/APN14.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N14/FAN14.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 002
            'numConvocatoria' : 'Convocatoria No. 002/2022.',
            'idConvocatoria' : 'Convocatoria2',
            'procedimientos' : [
        // Licitación N13
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N13-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica avenida Arboledas, municipio de Atitalaquia; ubicada en la localidad de Tlalminulpa, Municipio de Atitalaquia, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N13/N13.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N13/JAN13.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N13/APN13.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N13/FAN13.pdf`,
                    },
                    ],
                },
        // Licitación N12
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N12-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Insurgentes, municipio de Cuautepec; ubicada en la localidad de Cuautepec, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N12/N12.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N12/JAN12.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N12/APN12.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N12/FAN12.pdf`,
                    },
                    ],
                },
        // Licitación N11
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N11-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de camino El Mercillero - crucero Nexpa, primera etapa, en El Mercillero, municipio de Epazoyucan; ubicada en la localidad de El Mercillero, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N11/N11.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N11/JAN11.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N11/APN11.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N11/FAN11.pdf`,
                    },
                    ],
                },
        // Licitación N10
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N10-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Gabriel Barranco Pardo, municipio de Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N10/N10.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N10/JAN10.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N10/APN10.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N10/FAN10.pdf`,
                    },
                    ],
                },
        // Licitación N9
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N9-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle s/n de la localidad de Santiago Tepepa, municipio de Acaxochitlán; ubicada en la localidad de Tepepa (Santiago Tepepa), Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N9/N9.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N9/JAN9.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N9/APN9.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N9/FAN9.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 001
            'numConvocatoria' : 'Convocatoria No. 001/2022.',
            'idConvocatoria' : 'Convocatoria1',
            'procedimientos' : [
        // Licitación N8
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N8-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Gestoría y acometida para la sustitución y ampliación del Hospital General de Pachuca, (servicios generales); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N8/N8.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N8/JAN8.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N8/APN8.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N8/FAN8.pdf`,
                    },
                    ],
                },
        // Licitación N7
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N7-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Gestoría y acometida para la sustitución y ampliación del Hospital General de Pachuca, (urgencias); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N7/N7.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N7/JAN7.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N7/APN7.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N7/FAN7.pdf`,
                    },
                    ],
                },
        // Licitación N6
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N6-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Julio Armiño, municipio de Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N6/N6.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N6/JAN6.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N6/APN6.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }1/N6/AMDAPN6.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N6/FAN6.pdf`,
                    },
                    ],
                },
        // Licitación N5
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N5-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Manantial, colonia Guadalupe, municipio de Villa de Tezontepec; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N5/N5.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N5/JAN5.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N5/APN5.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N5/FAN5.pdf`,
                    },
                    ],
                },
        // Licitación N4
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N4-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Niños Héroes en la localidad de Cerro Verde, municipio de Cuautepec; ubicada en la localidad de Cerro Verde, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N4/N4.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N4/JAN4.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N4/APN4.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N4/FAN4.pdf`,
                    },
                    ],
                },
        // Licitación N3
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N3-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle 12 de Octubre, municipio de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N3/N3.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N3/JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N3/APN3.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N3/FAN3.pdf`,
                    },
                    ],
                },
        // Licitación N2
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N2-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación calle 16 de Septiembre Bocaja, municipio del Arenal; ubicada en la localidad de El Bocja, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N2/N2.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N2/JAN2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N2/APN2.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }1/N2/AMDAPN2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N2/FAN2.pdf`,
                    },
                    ],
                },
        // Licitación N1
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N1-2022.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 13 de mayo de 2022.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en Camino Viejo, municipio de San Salvador; ubicada en la localidad de San Antonio Zaragoza, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                    },
                    ],
                },
            ],
    },    
]